module.exports = __webpack_public_path__ + "fonts/fa-regular-400.a3d7d331957546ae10ad69bb44b83a04.woff2";